<template>
  <div>
   <video width="100%" height="100%" controls="controls" controlslist="nodownload" style="">
      <source :src="url">
    </video>
  </div>
</template>

<script>
  export default {
    props: [ "url" ],
  }
</script>